import { useState, useRef, useEffect } from 'react';

interface Job {
  id: number;
  hospitalType: string;
  monthlySalary: string;
  annualSalary: string;
  workStyle: string;
  overtime?: string;
  department: string;
  employmentType?: string;
  qualification?: string;
  allowance: string;
  bonus: string;
  benefits: string;
  holidays: string;
  location: string;
}

const jobs: Job[] = [
  {
    id: 1,
    hospitalType: '訪問看護付き有料老人ホーム',
    monthlySalary: '約40〜43.6万円',
    annualSalary: '約553〜610万円',
    workStyle: '2交代(訪問看護・施設看護混合)',
    overtime: '平均月10時間未満',
    department: '訪問看護 / 施設看護（緩和ケア系）',
    allowance: '夜勤手当・資格手当・精勤手当・通勤手当 等',
    bonus: '年2回（支給あり）',
    benefits: '社会保険・健康保険・厚生年金・雇用保険・労災・託児所・寮・退職金制度 等',
    holidays: '年間休日115日・週休2日制・夏季・年末年始休暇 等',
    location: '東京都'
  },
  {
    id: 2,
    hospitalType: '総合病院',
    monthlySalary: '31.3万円〜',
    annualSalary: '約478万円〜',
    workStyle: '2交代',
    overtime: '月8〜17時間程度',
    department: '一般急性期（消化器内科・循環器内科・整形外科 他多数）',
    allowance: '夜勤手当・通勤手当',
    bonus: '年2回',
    benefits: '寮・託児所・医療費免除・教育支援',
    holidays: '年間休日122日 / 4週8休以上',
    location: '埼玉県'
  },
  {
    id: 3,
    hospitalType: '有料老人ホーム / 訪問看護',
    monthlySalary: '40.0〜43.6万円',
    annualSalary: '約553〜599万円',
    workStyle: '2交代（訪問看護含む） or 日勤のみ案件あり',
    overtime: '月10時間程度',
    department: '訪問看護 / 介護・福祉系',
    allowance: '夜勤手当・資格手当・精勤手当',
    bonus: '年2回（3.5ヶ月 相当）',
    benefits: '社会保険・託児所・寮・退職金制度・車通勤可',
    holidays: '年間休日115日 / 週休2日制 / 夏季・年末年始休暇',
    location: '東京都'
  },
  {
    id: 4,
    hospitalType: 'ケアミックス病院',
    monthlySalary: '36.3万円',
    annualSalary: '約498万円',
    workStyle: '2交代',
    overtime: 'あり（部署により変動）',
    department: '内科・外科・整形外科・循環器科・小児科 他多数',
    allowance: '夜勤手当・各種手当',
    bonus: '約3ヶ月分',
    benefits: '寮・託児所・車通勤可・退職金制度',
    holidays: '年間休日115日 / 4週8休以上',
    location: '神奈川県'
  },
  {
    id: 5,
    hospitalType: '一般病院',
    monthlySalary: '34.2万円',
    annualSalary: '462万円',
    workStyle: '2交代（常勤）',
    department: '外科・整形外科・脳神経外科・内科・循環器科・消化器科・リハビリテーション科・放射線科・形成外科・呼吸器科・泌尿器科・麻酔科・歯科・リウマチ科・皮膚科・心臓血管外科・呼吸器外科',
    employmentType: '常勤（正看護師）',
    allowance: '夜勤手当（18,000円/回）・休日手当・通勤手当 全額支給等',
    bonus: '年2回（例：57〜68万円）',
    benefits: '社会保険完備・寮・託児所・退職金制度・車通勤可・保育サポート 等',
    holidays: '年間休日120日／4週8休制・夏季休暇・年末年始休暇・有給休暇・育児休業 等',
    location: '埼玉県'
  },
  {
    id: 6,
    hospitalType: '有床クリニック（病棟）',
    monthlySalary: '37.6万円',
    annualSalary: '約500万円',
    workStyle: '2交代',
    overtime: 'ほぼなし',
    department: '内科中心・高齢者ケア中心',
    employmentType: '常勤',
    qualification: '正看護師',
    allowance: '夜勤手当・資格手当・職務手当',
    bonus: '年2回',
    benefits: '社会保険・育児手当',
    holidays: '年間休日120日 / 4週8休制',
    location: '神奈川県'
  },
  {
    id: 7,
    hospitalType: 'ケアミックス病院',
    monthlySalary: '約36.5万円',
    annualSalary: '約530万円',
    workStyle: '2交代（一般病棟・療養病棟）',
    department: '内科系＋リハビリ科・専門内科多科目',
    allowance: '夜勤手当含む想定',
    bonus: '約92.2万円（一例）',
    holidays: '4週8休以上',
    location: '東京都'
  },
  {
    id: 8,
    hospitalType: 'ケアミックス病院',
    monthlySalary: '約34.9万円',
    annualSalary: '約525万円',
    workStyle: '2交代（常勤）',
    overtime: '記載なし',
    department: '病棟（療養含む）',
    allowance: '夜勤手当含む想定',
    bonus: '年4ヶ月分（目安）',
    benefits: '社保等',
    holidays: '年間125日 / 4週8休以上',
    location: '神奈川県'
  }
];

export default function JobCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const scrollLeft = container.scrollLeft;
      const cardWidth = container.offsetWidth * 0.85;
      const newIndex = Math.round(scrollLeft / cardWidth);
      setCurrentIndex(newIndex);
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      <div
        ref={scrollContainerRef}
        className="flex gap-3 overflow-x-auto snap-x snap-mandatory scrollbar-hide pb-2"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {jobs.map((job) => (
          <div
            key={job.id}
            className="flex-shrink-0 w-[85vw] bg-white border border-gray-200 rounded-lg p-4 shadow-sm snap-start"
          >
            <div className="bg-pink-500 text-white text-xs font-bold px-3 py-1.5 rounded-full inline-block mb-3">
              {job.hospitalType}
            </div>

            <div className="space-y-2.5">
              <div>
                <div className="text-xs text-gray-500 mb-0.5">月収</div>
                <div className="text-lg font-bold text-gray-900">{job.monthlySalary}</div>
              </div>

              <div>
                <div className="text-xs text-gray-500 mb-0.5">年収</div>
                <div className="text-base font-bold text-pink-600">{job.annualSalary}</div>
              </div>

              <div className="border-t border-gray-100 pt-2.5 space-y-2">
                <div className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-gray-400 text-sm"></i>
                  </div>
                  <div className="text-xs text-gray-700">
                    <span className="font-semibold">勤務形態:</span> {job.workStyle}
                  </div>
                </div>

                {job.overtime && (
                  <div className="flex items-start gap-2">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-timer-line text-gray-400 text-sm"></i>
                    </div>
                    <div className="text-xs text-gray-700">
                      <span className="font-semibold">残業:</span> {job.overtime}
                    </div>
                  </div>
                )}

                <div className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-hospital-line text-gray-400 text-sm"></i>
                  </div>
                  <div className="text-xs text-gray-700">
                    <span className="font-semibold">診療科:</span> {job.department}
                  </div>
                </div>

                {job.employmentType && (
                  <div className="flex items-start gap-2">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-briefcase-line text-gray-400 text-sm"></i>
                    </div>
                    <div className="text-xs text-gray-700">
                      <span className="font-semibold">雇用形態:</span> {job.employmentType}
                    </div>
                  </div>
                )}

                {job.qualification && (
                  <div className="flex items-start gap-2">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-award-line text-gray-400 text-sm"></i>
                    </div>
                    <div className="text-xs text-gray-700">
                      <span className="font-semibold">資格:</span> {job.qualification}
                    </div>
                  </div>
                )}

                <div className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-money-dollar-circle-line text-gray-400 text-sm"></i>
                  </div>
                  <div className="text-xs text-gray-700">
                    <span className="font-semibold">手当:</span> {job.allowance}
                  </div>
                </div>

                <div className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-gift-line text-gray-400 text-sm"></i>
                  </div>
                  <div className="text-xs text-gray-700">
                    <span className="font-semibold">賞与:</span> {job.bonus}
                  </div>
                </div>

                {job.benefits && (
                  <div className="flex items-start gap-2">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-heart-line text-gray-400 text-sm"></i>
                    </div>
                    <div className="text-xs text-gray-700">
                      <span className="font-semibold">福利厚生:</span> {job.benefits}
                    </div>
                  </div>
                )}

                <div className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-calendar-line text-gray-400 text-sm"></i>
                  </div>
                  <div className="text-xs text-gray-700">
                    <span className="font-semibold">休日:</span> {job.holidays}
                  </div>
                </div>

                <div className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-gray-400 text-sm"></i>
                  </div>
                  <div className="text-xs text-gray-700">
                    <span className="font-semibold">勤務地:</span> {job.location}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* インジケーター */}
      <div className="flex justify-center gap-1.5 mt-4">
        {jobs.map((_, index) => (
          <div
            key={index}
            className={`h-1.5 rounded-full transition-all ${
              index === currentIndex
                ? 'w-6 bg-pink-500'
                : 'w-1.5 bg-gray-300'
            }`}
          />
        ))}
      </div>
    </div>
  );
}